<template>
  <div class="ms-shell" style="margin-top: 20px">
    <div class="ms-layout">

      <!-- Collapseable left nav -->
      <div v-if="!horizonNavActive" class="ms-nav-wrapper" :class="{ 'ms-nav-collapsed': navCollapsed }">
        <div class="ms-nav-inner">
          <router-link
            :to="{ name: 'map_dashboard' }"
            class="ms-nav-home"
            :class="{ active: $route.name === 'map_dashboard' }"
          >
            <i class="fa fa-th-large ms-nav-home-icon"></i>
            Maps
          </router-link>

          <router-link
            v-for="item in mapItems"
            :key="item.route || item.path"
            :to="item.path ? { path: item.path } : { name: item.route }"
            :target="item.external ? '_blank' : null"
            :rel="item.external ? 'noopener' : null"
            class="ms-nav-item"
            :class="{ active: item.route && $route.name === item.route }"
          >
            <i :class="'fa ' + item.icon + ' ms-nav-item-icon'" aria-hidden="true"></i>
            {{ item.name }}
            <i v-if="item.external" class="fa fa-external-link ms-nav-ext-icon" aria-hidden="true"></i>
          </router-link>
        </div>

        <button
          class="ms-nav-toggle"
          @click="toggleNav"
          :title="navCollapsed ? 'Expand menu' : 'Collapse menu'"
          :aria-label="navCollapsed ? 'Expand menu' : 'Collapse menu'"
        >
          <i class="fa" :class="navCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
        </button>
      </div>

      <!-- Page content -->
      <div class="ms-content">
        <router-view />
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { buildMapItems } from '@/utils/map_pages'
import horizonNavMixin from '@/nav/horizon_nav_mixin'

export default {
  name: 'map_shell',
  mixins: [horizonNavMixin],
  data() {
    return {
      navCollapsed: false,
      navUserToggled: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    mapItems() { return buildMapItems(this.user, this.viewAs) },
  },
  mounted() {
    this._onResize = () => {
      // Keep the nav responsive to window width unless the user has explicitly toggled it
      if (this.navUserToggled) return
      this.navCollapsed = window.innerWidth < 1600
    }
    window.addEventListener('resize', this._onResize)
    this._onResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._onResize)
  },
  methods: {
    toggleNav() {
      this.navCollapsed = !this.navCollapsed
      this.navUserToggled = true
    },
  },
}
</script>

<style scoped>
.ms-layout {
  display: flex;
  align-items: flex-start;
}

.ms-nav-wrapper {
  position: relative;
  display: flex;
  flex-shrink: 0;
}

.ms-nav-inner {
  width: 250px;
  min-width: 250px;
  overflow: hidden;
  transition: width 0.22s ease, min-width 0.22s ease;
  background-color: #e8eef5;
  border-right: 2px solid #dee2e6;
  padding: 12px 0;
}

.ms-nav-collapsed .ms-nav-inner {
  width: 0;
  min-width: 0;
  border-right: none;
  padding: 0;
}

.ms-nav-home {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  font-size: 15px;
  font-weight: 600;
  color: #333 !important;
  text-decoration: none !important;
  border-bottom: 2px solid #c8d8e8;
  white-space: nowrap;
  background: transparent;
  transition: background 0.12s;
}

.ms-nav-home:hover {
  background-color: #d0dfee;
  text-decoration: none !important;
}

.ms-nav-home.active {
  background-color: steelblue !important;
  color: #fff !important;
  border-bottom-color: #f0f0f0;
}

.ms-nav-home-icon {
  margin-right: 7px;
  font-size: 12px;
}

.ms-nav-item {
  display: block;
  padding: 9px 16px 9px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #333 !important;
  text-decoration: none !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-left: 3px solid transparent;
  position: relative;
  transition: background 0.1s, border-color 0.1s;
}

.ms-nav-item:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 18px;
  right: 16px;
  bottom: 0;
  height: 1px;
  background-color: #d8e2ee;
}

.ms-nav-item:hover {
  background-color: #dce8f5;
  text-decoration: none !important;
}

.ms-nav-item.active {
  background-color: #dce8f5;
  border-left-color: steelblue;
  color: steelblue !important;
  font-weight: 600;
}

.ms-nav-item-icon {
  width: 16px;
  margin-right: 7px;
  color: steelblue;
  font-size: 12px;
}

.ms-nav-ext-icon {
  margin-left: 5px;
  color: #9aa7b4;
  font-size: 10px;
}

.ms-nav-toggle {
  position: absolute;
  top: 12px;
  right: -20px;
  width: 20px;
  height: 36px;
  background: #e8eef5;
  border: 1px solid #c8d8e8;
  border-left: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a6785;
  font-size: 11px;
  padding: 0;
  z-index: 10;
  transition: background 0.15s;
}

.ms-nav-toggle:hover {
  background: #d0dfee;
  color: steelblue;
}

.ms-nav-toggle:focus {
  outline: none;
}

.ms-content {
  flex: 1;
  min-width: 0;
  padding-left: 24px;
}
</style>
